import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../home/Navbar.css";
import "../home/mediaCss.css";
import { Row, Modal, Button, Tab, Tabs } from "react-bootstrap";
import { Carousel } from "react-bootstrap";

import logoWhite from "../../Images/logo/isbm-university-white.webp";
import c1_image from "../../Images/commonimg/isbm12.webp";

import academicsImg1 from "../../Images/commonimg/acadcemics-1.webp";
import academicsImg2 from "../../Images/commonimg/acadcemics-2.webp";
import academicsImg3 from "../../Images/commonimg/acadcemics-3.webp";
import academicsImg4 from "../../Images/commonimg/acadcemics-4.webp";

import placementImg1 from "../../Images/placement/placement1.webp";
import placementImg2 from "../../Images/placement/placement2.webp";
import placementImg3 from "../../Images/placement/placement3.webp";
import placementImg4 from "../../Images/placement/placement4.webp";
import placementImg5 from "../../Images/placement/placement5.webp";
import placementImg6 from "../../Images/placement/placement6.webp";
import placementImg7 from "../../Images/placement/placement7.webp";

import campusImg1 from "../../Images/campus/campus-1.webp";
import campusImg2 from "../../Images/campus/campus-2.webp";
import campusImg3 from "../../Images/campus/campus-3.webp";
import campusImg4 from "../../Images/campus/campus-4.webp";

const FETCH_DEBOUNCE = 150;

const Menubar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuWidth, setMenuWidth] = useState(0);

  // dropdown control - now using click instead of hover
  const [activeMenu, setActiveMenu] = useState(null);

  // schools/courses
  const [hoveredSchool, setHoveredSchool] = useState(null);
  const [schools, setSchools] = useState([]);
  const [coursesCache, setCoursesCache] = useState({});
  const debouncedFetchRef = useRef(null);

  // search modal
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const headerRef = useRef(null);
  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/schoolsApi"
        );
        setSchools(res.data?.data || []);
      } catch (e) {
        console.error("Error fetching schools:", e);
      }
    })();
  }, []);

  useEffect(() => {
    const remeasure = () => {
      if (headerRef.current) setMenuWidth(headerRef.current.offsetWidth);
    };
    remeasure();
    window.addEventListener("resize", remeasure, { passive: true });
    return () => window.removeEventListener("resize", remeasure);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".nav-item.dropdown")) {
        setActiveMenu(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!hoveredSchool) return;
    if (coursesCache[hoveredSchool]) return;

    if (debouncedFetchRef.current) clearTimeout(debouncedFetchRef.current);
    debouncedFetchRef.current = setTimeout(async () => {
      try {
        const url = `https://isbmuniversity.edu.in/admin-portal/coursesList${hoveredSchool}`;
        const res = await axios.get(url);
        setCoursesCache((p) => ({
          ...p,
          [hoveredSchool]: res.data?.data || [],
        }));
      } catch (e) {
        console.error("Error fetching courses:", e);
        setCoursesCache((p) => ({ ...p, [hoveredSchool]: [] }));
      }
    }, FETCH_DEBOUNCE);

    return () => {
      if (debouncedFetchRef.current) clearTimeout(debouncedFetchRef.current);
    };
  }, [hoveredSchool, coursesCache]);

  const academicsCarousel = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const placementCarousel = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 1600,
    rtl: true,
  };
  const campusCarousel = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 1600,
    rtl: true,
  };

  // Filter out "School of Health and Allied Science" and "School of Pharmacy"
  const filteredSchools = useMemo(() => {
    return schools.filter(
      (school) =>
        school.name !== "school-of-health-and-allied-science" &&
        school.name !== "school-of-pharmacy"
    );
  }, [schools]);

  // Create custom school of health entry
  const schoolOfHealthEntry = useMemo(
    () => ({
      id: 100,
      name: "school-of-health-and-allied-science",
      title: "School of Health and Allied Science",
      description:
        "School of Health combines pharmacy and healthcare education",
      status: "Active",
    }),
    []
  );

  const getAerenPharmacyCourses = useMemo(() => {
    if (!coursesCache["/school-of-pharmacy"]) return [];

    // Filter only courses with title containing "Diploma in Pharmacy" or "D Pharma"
    return coursesCache["/school-of-pharmacy"].filter(
      (course) =>
        course.title.toLowerCase().includes("diploma in pharmacy") ||
        course.title.toLowerCase().includes("d pharma")
    );
  }, [coursesCache["/school-of-pharmacy"]]);

  // dropdown content - include filtered schools and custom school of health
  const dropdownContent = useMemo(() => {
    const allSchools = [
      ...filteredSchools.map((school, index) => ({
        key: index,
        label: school.title,
        link: `/${String(school.name || "")
          .toLowerCase()
          .replace(/\s+/g, "-")}`,
      })),
      {
        key: "school-of-health-and-allied-science",
        label: schoolOfHealthEntry.title,
        link: `/school-details/school-of-health-and-allied-science`,
        isHealthSchool: true,
      },
    ];

    // Sort alphabetically by label
    allSchools.sort((a, b) => a.label.localeCompare(b.label));

    return {
      Programmes: allSchools,
    };
  }, [filteredSchools, schoolOfHealthEntry]);

  // search suggestions source (pages + schools + cached courses)
  const searchIndex = useMemo(() => {
    const base = [
      ...Object.entries(dropdownContent).flatMap(([_, items]) =>
        items.map((i) => ({ label: i.label, link: i.link }))
      ),
      ...filteredSchools.map((s) => ({
        label: `School: ${s.title}`,
        link: `/school-details/${String(s.name || "")
          .toLowerCase()
          .replace(/\s+/g, "-")}`,
      })),
    ];

    // Add School of Health to search index
    base.push({
      label: `School: ${schoolOfHealthEntry.title}`,
      link: `/school-details/school-of-health-and-allied-science`,
    });

    Object.values(coursesCache).forEach((arr) => {
      (arr || []).forEach((c) => {
        base.push({
          label: `Course: ${c.title}`,
          link: `/course-details/${c.name}`,
        });
      });
    });
    return base;
  }, [dropdownContent, filteredSchools, schoolOfHealthEntry, coursesCache]);

  const filteredSuggestions = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return [];
    return searchIndex
      .filter((item) => item.label.toLowerCase().includes(q))
      .slice(0, 10);
  }, [searchTerm, searchIndex]);

  const goSearch = (dest, openInNewTab = false) => {
    if (dest) {
      if (openInNewTab) {
        window.open(dest, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = dest;
      }
    } else if (searchTerm.trim()) {
      const searchUrl = `/search?q=${encodeURIComponent(searchTerm.trim())}`;
      if (openInNewTab) {
        window.open(searchUrl, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = searchUrl;
      }
    }

    setSearchOpen(false);
  };

  // Handle hover for school of pharmacy specifically
  const handleSchoolHover = (schoolLink) => {
    if (schoolLink === "/school-details/school-of-health-and-allied-science") {
      // When hovering over School of Health, set hoveredSchool to school-of-pharmacy
      // to fetch pharmacy courses
      setHoveredSchool("/school-of-pharmacy");
    } else {
      setHoveredSchool(schoolLink);
    }
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-dark bg-blue custom-navbar ${
          scrolled ? "fixed-top scrolled" : ""
        }`}
      >
        <div className="container-fluid p-0">
          <Row className="justify-content-between w-100 m-0 ps-5">
            <div className="logobar col-md-2 p-0">
              <a className="navbar-brand" href="/">
                <img className="logo" src={logoWhite} alt="University Logo" />
              </a>
            </div>

            <div className="menubar col-md-10 p-0">
              <div className="menu_nav">
                <div className="upper-menu">
                  <ul>
                    {/* SEARCH BUTTON (opens modal) */}
                    <li className="right-border">
                      <Button
                        variant="light"
                        size="sm"
                        className="bg-transparent p-0 border-0"
                        onClick={() => setSearchOpen(true)}
                        aria-label="Open search"
                      >
                        <i className="ti ti-search me-1 text-white" />
                      </Button>
                    </li>
                    <li className="right-border">
                      <a href="/academic-syllabus" target="_blank" className="info_link">
                        Syllabus
                      </a>
                    </li>
                    <li className="right-border">
                      <a
                        href="https://isbmuniversity.online/"
                        target="_blank"
                        className="info_link"
                      >
                        Student Login
                      </a>
                    </li>
                    <li className="right-border">
                      <a href="/iqac" target="_blank" className="info_link">
                        IQAC
                      </a>
                    </li>
                    <li className="right-border">
                      <a
                        href="/e-library"
                        target="_blank"
                        className="info_link"
                      >
                        e-Library
                      </a>
                    </li>
                    <li className="right-border">
                      <a href="/research" target="_blank" className="info_link">
                        Ph.D Research
                      </a>
                    </li>
                    <li className="right-border">
                      <a
                        href="/pay-fees-online"
                        target="_blank"
                        className="info_link"
                      >
                        Pay Online
                      </a>
                    </li>
                    <li className="right-border">
                      <a
                        href="/apply-online"
                        target="_blank"
                        className="info_link"
                      >
                        Apply Online
                      </a>
                    </li>
                    <li className="right-border">
                      <a
                        href="/contact-us"
                        target="_blank"
                        className="info_link"
                      >
                        Contact Us
                      </a>
                    </li>
                    <li className="">
                      Call us at{" "}
                      <a
                        href="tel:+91-9373199999"
                        target="_blank"
                        className="toll-btn landline"
                      >
                        +91-9373199999
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="d-flex align-items-center">
                  <ul className="menu_header mb-0" ref={headerRef}>
                    {/* ABOUT US */}
                    <li className="nav-item">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="about-us"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        About Us
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="about-us"
                        style={{ width: "100%" }}
                      >
                        {/* Carousel Section */}
                        <div className="col-12">
                          <div className="row m-0 p-4">
                            <div className="col-6">
                              <Carousel
                                className="menubar-carousel"
                                indicators={false}
                                controls={false}
                              >
                                <Carousel.Item
                                  interval={3000}
                                  data-pause="true"
                                >
                                  <h3 className="text-decoration-underline mb-3">
                                    Knowledge Meets Innovation
                                  </h3>
                                  <p>
                                    <small>
                                      ISBM University is a UGC and
                                      NAAC-recognized institution dedicated to
                                      academic innovation and excellence.
                                    </small>
                                  </p>
                                  <p>
                                    <small>
                                      It offers a future-focused learning
                                      environment that nurtures talent and
                                      leadership.
                                    </small>
                                  </p>
                                </Carousel.Item>

                                <Carousel.Item
                                  interval={3000}
                                  data-pause="true"
                                >
                                  <h3 className="text-decoration-underline mb-3">
                                    Excellence Engineered for Tomorrow
                                  </h3>
                                  <p>
                                    <small>
                                      Our programs blend theory with hands-on
                                      experience.
                                    </small>
                                  </p>
                                  <p>
                                    <small>
                                      From engineering to management, each
                                      course empowers practical skills.
                                    </small>
                                  </p>
                                </Carousel.Item>

                                <Carousel.Item
                                  interval={3000}
                                  data-pause="true"
                                >
                                  <h3 className="text-decoration-underline mb-3">
                                    Recognized, Respected, Remarkable.
                                  </h3>
                                  <p>
                                    <small>
                                      Recognized by UGC, AICTE, AIU, PCI and
                                      accredited by NAAC.
                                    </small>
                                  </p>
                                  <p>
                                    <small>
                                      Committed to top regulatory and quality
                                      benchmarks.
                                    </small>
                                  </p>
                                </Carousel.Item>

                                <Carousel.Item
                                  interval={3000}
                                  data-pause="true"
                                >
                                  <h3 className="text-decoration-underline mb-3">
                                    Your Career, Our Commitment
                                  </h3>
                                  <p>
                                    <small>
                                      Global careers via internships, soft
                                      skills, and industry tie-ups.
                                    </small>
                                  </p>
                                  <p>
                                    <small>
                                      Expert-led sessions and placement support
                                      ensure outcomes.
                                    </small>
                                  </p>
                                </Carousel.Item>
                              </Carousel>
                            </div>

                            <div className="col-6">
                              <img
                                src={c1_image}
                                loading="lazy"
                                height={200}
                                alt="About ISBM"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Links Section */}
                        <div className="col-12 p-0">
                          <div className="row justify-content-between m-0">
                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/about-us"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  About ISBM University
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/vision-mission"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Vision and Mission
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/leadership-and-management"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Leadership and Management
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/university-administration"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  University Administration
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/board-advisor"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Board of Advisors
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/dignitaries-messages"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Messages of the Dignitaries
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/statues-and-ordinance"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Statutes and Ordinances
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/accreditation-and-recognitions"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Accreditations and Recognitions
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/awards"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">Awards</div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/media-coverage"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">Media Coverage</div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="https://rajbhavancg.gov.in/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">Raj Bhavan</div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>

                            <div className="col-lg-4 col-md-6 p-0 dropdown-item-border-bottom">
                              <a
                                href="/code-of-conduct-and-rti"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="dropdown-item d-flex align-items-center"
                              >
                                <div className="col-11 p-0">
                                  Code of Conduct
                                </div>
                                <div className="col-1 dropdown-item-icon p-0 text-white">
                                  <i className="ti ti-arrow-right"></i>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* ACADEMICS */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="academics"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Academics
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="academics"
                        style={{ width: "100%" }}
                      >
                        <div className="row m-0">
                          {/* Left Column - Dropdown Items */}
                          <div className="col-6 p-0">
                            <div className="row justify-content-between m-0">
                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/academic-philosophy"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    Academic Philosophy
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/academic-partner"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    Academic Partners
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/online-resources"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    Online Resources
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/teaching-methodology-pedagogy"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    Teaching Methodology / Pedagogy
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/mooc-with-isbm"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    MOOC's with ISBM University
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/mous-and-collaborations"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    MOU's and Collaborations
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/blog"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">Blogs</div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <a
                                  href="/academic-calender"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="dropdown-item d-flex align-items-center text-white"
                                >
                                  <div className="col-11 p-0">
                                    Academic Calendar
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 ps-3">
                            <Slider
                              {...campusCarousel}
                              className="academics-carousel"
                            >
                              <div className="placementImg">
                                <img
                                  src={campusImg1}
                                  loading="lazy"
                                  alt="campus 1"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg2}
                                  loading="lazy"
                                  alt="campus 2"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg3}
                                  loading="lazy"
                                  alt="campus 3"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg4}
                                  loading="lazy"
                                  alt="campus 4"
                                />
                              </div>
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* PROGRAMMES */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="programmes"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Programmes
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="programmes"
                        style={{ width: "100%" }}
                      >
                        <div className="row m-0">
                          <div className="col-5 p-0">
                            <div className="row justify-content-between m-0 programmes-list">
                              {dropdownContent["Programmes"].map(
                                (subItem, subIndex) => (
                                  <div
                                    className="col-12 dropdown-item-border-bottom"
                                    key={subIndex}
                                    onMouseEnter={() =>
                                      handleSchoolHover(subItem.link)
                                    }
                                  >
                                    <div
                                      className={`dropdown-item col-6 ${
                                        hoveredSchool === subItem.link ||
                                        (subItem.isHealthSchool &&
                                          hoveredSchool ===
                                            "/school-of-pharmacy")
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      <a
                                        href={
                                          subItem.isHealthSchool
                                            ? "/school-details/school-of-health-and-allied-science"
                                            : `/school-details${subItem.link}`
                                        }
                                        target={subItem.target || "/"}
                                        className="row justify-content-between mx-1 text-decoration-none text-white"
                                      >
                                        <div className="col-11 p-0">
                                          {subItem.label}
                                        </div>
                                        <div className="col-1 dropdown-item-icon p-0 text-white">
                                          <i className="ti ti-arrow-right"></i>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                          <div className="col-7 p-3">
                            {/* Check if School of Health is hovered */}
                            {hoveredSchool === "/school-of-pharmacy" && (
                              <div>
                                <h6 className="fw-bold mb-3">
                                  School of Pharmacy Courses Offered:
                                </h6>
                                <ul className="list-unstyled">
                                  {(coursesCache["/school-of-pharmacy"] || [])
                                    .length > 0 ? (
                                    coursesCache["/school-of-pharmacy"].map(
                                      (course, idx) => (
                                        <li key={idx} className="mb-3">
                                          <div className="row justify-content-between dropdown-item-border-bottom mx-1">
                                            <div className="col-11 p-0">
                                              <a
                                                className="course-item col-6"
                                                href={`/course-details/${course.name}`}
                                                target={course.target || "/"}
                                              >
                                                {course.title}
                                              </a>
                                            </div>
                                            <div className="col-1 dropdown-item-icon p-0">
                                              <i className="ti ti-arrow-right"></i>
                                            </div>
                                          </div>
                                        </li>
                                      )
                                    )
                                  ) : (
                                    <li className="text-muted">
                                      Loading pharmacy courses...
                                    </li>
                                  )}
                                </ul>
                                <h6 className="fw-bold mt-5 mb-3">
                                  Alpha Pharmacy Courses Offered:
                                </h6>
                                <ul className="list-unstyled">
                                  {getAerenPharmacyCourses.length > 0 ? (
                                    getAerenPharmacyCourses.map(
                                      (course, idx) => (
                                        <li key={idx} className="mb-3">
                                          <div className="row justify-content-between dropdown-item-border-bottom mx-1">
                                            <div className="col-11 p-0">
                                              <a
                                                className="course-item col-6"
                                                href={`/course-details/${course.name}`}
                                                target={course.target || "/"}
                                              >
                                                {course.title}
                                              </a>
                                            </div>
                                            <div className="col-1 dropdown-item-icon p-0">
                                              <i className="ti ti-arrow-right"></i>
                                            </div>
                                          </div>
                                        </li>
                                      )
                                    )
                                  ) : (
                                    <li className="text-muted">
                                      Loading Alpha Pharmacy courses...
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}

                            {/* For other schools */}
                            {hoveredSchool &&
                              hoveredSchool !== "/school-of-pharmacy" && (
                                <div>
                                  <h6 className="fw-bold mb-3">
                                    Courses Offered:
                                  </h6>
                                  <ul className="list-unstyled">
                                    {(coursesCache[hoveredSchool] || [])
                                      .length > 0 ? (
                                      coursesCache[hoveredSchool].map(
                                        (course, idx) => (
                                          <li key={idx} className="mb-3">
                                            <div className="row justify-content-between dropdown-item-border-bottom mx-1">
                                              <div className="col-11 p-0">
                                                <a
                                                  className="course-item col-6"
                                                  href={`/course-details/${course.name}`}
                                                  target={course.target || "/"}
                                                >
                                                  {course.title}
                                                </a>
                                              </div>
                                              <div className="col-1 dropdown-item-icon p-0">
                                                <i className="ti ti-arrow-right"></i>
                                              </div>
                                            </div>
                                          </li>
                                        )
                                      )
                                    ) : hoveredSchool ? (
                                      <li className="text-muted">
                                        Loading courses...
                                      </li>
                                    ) : (
                                      <li className="text-muted">
                                        Select a school to view courses
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              )}

                            {/* Default message when no school is hovered */}
                            {!hoveredSchool && (
                              <div className="text-muted">
                                Hover over a school to view courses
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* ADMISSIONS */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="admissions"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Admissions
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="admissions"
                        style={{ width: "100%" }}
                      >
                        <div className="row m-0">
                          {/* Left Side - Links */}
                          <div className="col-6 p-0">
                            <div className="row justify-content-between m-0">
                              {/* Programme Links */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/programmes-and-eligibilities"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Programmes and Eligibilities
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/programmes-by-qualification"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Programmes By Qualification
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/skill-development"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Skill Development
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/research"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">Research</div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/apply-online"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Apply Online
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/pay-fees-online"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Online Payment
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/payment-procedure-guidelines"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Payment Procedure Guidelines
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/admission-procedure-guidelines"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Admission Procedure Guidelines
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="dropdown-item">
                                  <a
                                    href="/admission-help-desk"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Admission Helpdesk
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Right Side - Cards */}
                          <div className="col-6 ps-3">
                            <div className="adm-card p-3">
                              <h4 className="text-decoration-underline">
                                Fill the Application Form
                              </h4>
                              <p>
                                <small>
                                  Complete the online form with accurate
                                  academic and personal details.
                                </small>
                              </p>
                            </div>
                            <div className="adm-card p-3">
                              <h4 className="text-decoration-underline">
                                Get Counselling
                              </h4>
                              <p>
                                <small>
                                  Talk to our experts to pick the right course.
                                </small>
                              </p>
                            </div>
                            <div className="adm-card p-3">
                              <h4 className="text-decoration-underline">
                                Pay & Submit
                              </h4>
                              <p>
                                <small>
                                  Pay the fee and submit for final review.
                                </small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* STUDENT SERVICES */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="student-services"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Student Services
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="student-services"
                        style={{ width: "100%" }}
                      >
                        <div className="row justify-content-between m-0">
                          {/* Left Column */}
                          <div className="col-lg-6 col-12 p-0">
                            <div className="row justify-content-between m-0">
                              {/* FAQ */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/faqs"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">FAQ</div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Scholarship */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/scholarship"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Scholarship
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Anti-Ragging Policy */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/anti-ragging-policy"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Anti-Ragging Policy
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Download */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/download-form"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">Download</div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Various Applications */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/various-application"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">Various Application</div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Alumni Portal */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="https://isbmalumni.com/"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Alumni Portal
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Voter Portal */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="https://voterportal.eci.gov.in/"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Voter Portal
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              {/* Anti-Ragging Committee */}
                              <div className="col-12 dropdown-item-border-bottom">
                                <div className="dropdown-item">
                                  <a
                                    href="/anti-ragging-committee"
                                    target="_blank"
                                    className="row justify-content-between mx-1 text-decoration-none text-white"
                                  >
                                    <div className="col-11 p-0">
                                      Anti-Ragging Committee
                                    </div>
                                    <div className="col-1 dropdown-item-icon p-0 text-white">
                                      <i className="ti ti-arrow-right"></i>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>

                            {/* Anti-Ragging Squad */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/anti-ragging-squad"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Anti-Ragging Squad
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 col-12 p-0">
                            {/* SC & ST Committee */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/sc-and-st-committee"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Scheduled Caste and Scheduled Tribe
                                    Committee
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* OBC Committee */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/obc-committee"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Other Backward Class Committee
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* Grievance Committee */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/student-grievance-committee"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Student's Grievance Redressal Committee
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* ICC */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/icc-committee"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Internal Complaints Committee
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* Cultural Committee */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/cultural-committee"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Cultural Committee
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* Student Council */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/student-council"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Student Council
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* Student ERP */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="https://isbmuniversity.online/"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">Student ERP</div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* Student Grievance */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/student-grievance"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    Student Grievance
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* PLACEMENTS */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="placements"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Placements
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="placements"
                        style={{ width: "100%" }}
                      >
                        <div className="row m-0">
                          {/* Left Side - Links */}
                          <div className="col-6 p-0">
                            <div className="row justify-content-between m-0">
                              {[
                                {
                                  label: "About Placements",
                                  link: "/about-placements",
                                },
                                {
                                  label: "Career Counselling",
                                  link: "/career-counselling",
                                },
                                {
                                  label: "Global Readiness",
                                  link: "/global-readiness",
                                },
                                { label: "Recruiters", link: "/recruiters" },
                                {
                                  label:
                                    "Campus Recruitment and Interview Training",
                                  link: "/campus-recruitment-interview-training",
                                },
                                {
                                  label: "Work at ISBM University",
                                  link: "/work-at-isbmu",
                                },
                              ].map((item, idx) => (
                                <div
                                  className="col-12 dropdown-item-border-bottom"
                                  key={idx}
                                >
                                  <div className="dropdown-item">
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      className="row justify-content-between mx-1 text-decoration-none text-white"
                                    >
                                      <div className="col-11 p-0">
                                        {item.label}
                                      </div>
                                      <div className="col-1 dropdown-item-icon p-0 text-white">
                                        <i className="ti ti-arrow-right"></i>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Right Side - Carousel */}
                          <div className="col-6 ps-3 placement-carousel">
                            <Slider
                              {...placementCarousel}
                              className="academics-carousel"
                            >
                              {[
                                placementImg1,
                                placementImg2,
                                placementImg3,
                                placementImg4,
                                placementImg5,
                                placementImg6,
                                placementImg7,
                              ].map((img, index) => (
                                <div className="placementImg" key={index}>
                                  <img
                                    src={img}
                                    alt={`placement ${index + 1}`}
                                    loading="lazy"
                                  />
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* CAMPUS */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="ampus"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Campus
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="Campus"
                        style={{ width: "100%" }}
                      >
                        <div className="row m-0">
                          {/* Left Side - Links */}
                          <div className="col-6 p-0">
                            <div className="row justify-content-between m-0">
                              {[
                                // { label: "Campus Infrastructure", link: "/campus-infrastructure" },
                                {
                                  label: "Gariyaband Campus",
                                  link: "/gariyaband-campus",
                                },
                                {
                                  label: "Raipur Campus",
                                  link: "/raipur-campus",
                                },
                                { label: "Library", link: "/library" },
                                { label: "Laboratory", link: "/laboratory" },
                                {
                                  label: "Sports Facilities",
                                  link: "/sports-facilities",
                                },
                                {
                                  label: "Extra Curricular",
                                  link: "/extra-curricular",
                                },
                                {
                                  label: "Digitized Learning System",
                                  link: "/digitized-learning-system",
                                },
                                {
                                  label: "Bus Transportation",
                                  link: "/bus-transportation",
                                },
                                { label: "Hostel", link: "/hostel" },
                              ].map((item, idx) => (
                                <div
                                  className="col-12 dropdown-item-border-bottom"
                                  key={idx}
                                >
                                  <div className="dropdown-item">
                                    <a
                                      href={item.link}
                                      target="_blank"
                                      className="row justify-content-between mx-1 text-decoration-none text-white"
                                    >
                                      <div className="col-11 p-0">
                                        {item.label}
                                      </div>
                                      <div className="col-1 dropdown-item-icon p-0 text-white">
                                        <i className="ti ti-arrow-right"></i>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Right Side - Carousel */}
                          <div className="col-6 ps-3">
                            <Slider
                              {...campusCarousel}
                              className="academics-carousel"
                            >
                              <div className="placementImg">
                                <img
                                  src={campusImg1}
                                  loading="lazy"
                                  alt="campus 1"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg2}
                                  loading="lazy"
                                  alt="campus 2"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg3}
                                  loading="lazy"
                                  alt="campus 3"
                                />
                              </div>
                              <div className="placementImg">
                                <img
                                  src={campusImg4}
                                  loading="lazy"
                                  alt="campus 4"
                                />
                              </div>
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* INTERNATIONAL */}
                    <li className="nav-item ">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="International"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        International
                      </a>

                      <div
                        className="dropdown-menu"
                        aria-labelledby="International"
                        style={{ width: "100%" }}
                      >
                        <div className="col-12 p-0">
                          <div className="row justify-content-between m-0">
                            {/* International Partnerships */}
                            <div className="col-12 dropdown-item-border-bottom">
                              <div className="dropdown-item">
                                <a
                                  href="/international-partnerships"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    International Partnerships
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>

                            {/* International Students */}
                            <div className="col-12">
                              <div className="dropdown-item">
                                <a
                                  href="/international-students"
                                  target="_blank"
                                  className="row justify-content-between mx-1 text-decoration-none text-white"
                                >
                                  <div className="col-11 p-0">
                                    International Students
                                  </div>
                                  <div className="col-1 dropdown-item-icon p-0 text-white">
                                    <i className="ti ti-arrow-right"></i>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </nav>

      {/* SEARCH MODAL */}
      <Modal
        show={searchOpen}
        onHide={() => setSearchOpen(false)}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Search ISBM University</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <input
              type="text"
              className="form-control"
              placeholder="Search courses, schools, or pages…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") goSearch();
              }}
              autoFocus
            />
          </div>

          {searchTerm.trim() && (
            <div className="mt-3">
              {filteredSuggestions.length ? (
                <div className="list-group">
                  {filteredSuggestions.map((s, idx) => (
                    <button
                      key={`${s.link}-${idx}`}
                      type="button"
                      className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                      onClick={() => goSearch(s.link, true)}
                    >
                      <span>{s.label}</span>
                      <i className="ti ti-arrow-right" />
                    </button>
                  ))}
                </div>
              ) : (
                <div className="text-muted small">
                  No suggestions. Press Enter to search the site.
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSearchOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Menubar;
